export const CHART_PALETTE = [
  '#21b3ff',
  '#00c100',
  '#f7cb00',
  '#ff6a16',
  '#c62828',
  '#9c27b0',
  '#00bcd4',
  '#4caf50',
  '#ff5722',
  '#607d8b',
] as const;

export const CHART_PALETTE_TYPE = ['#21b3ff', '#3f8ecf', '#7ac9f5', '#0080cc', '#bce8ff'];

export const CHART_PALETTE_SUBTYPE = ['#00c100', '#018701', '#4dd74d', '#86efac', '#005f00'];

export const CHART_PALETTE_ITEM = ['#f7cb00', '#ff6a16', '#ea2d0a', '#c68600', '#ff9a5c'];

export const VARIANCE_ENTERED_COLOR = '#64B5F6';
export const VARIANCE_CLOSED_COLOR_LIGHT = '#111111';
export const VARIANCE_CLOSED_COLOR_DARK = '#6b7280';
export const VARIANCE_LINE_COLOR_ENTERED = '#1a1a1a';
export const VARIANCE_LINE_COLOR_ENTERED_DARK = '#e5e7eb';
export const VARIANCE_YEAR_LABEL_COLOR = '#9ca3af';

export const SMILEBACK_CSAT_LINE_COLOR = '#4d4d4f';
export const SMILEBACK_CSAT_LINE_COLOR_DARK = '#e5e7eb';

export const DOUGHNUT_CENTER_COLOR = '#21b3ff';
export const DOUGHNUT_MAX_ITEMS = 5;
export const DOUGHNUT_MIN_PCT_LABEL = 5;
export const DOUGHNUT_LABEL_MAX_CHARS = 22;

export const BAR_PERCENTAGE = 1.0;
export const BAR_CATEGORY_PERCENTAGE = 0.55;

const CHART_HOVER_ALPHA = 'D9';

export const withChartHoverAlpha = (hexColor: string): string => `${hexColor}${CHART_HOVER_ALPHA}`;
